module.exports = __webpack_public_path__ + "static/flags/SF-e09d2f1ff6e582b1c78e6897fab3655a.gif";